import { createSelectorCreator, defaultMemoize } from 'reselect'
import { State } from '../../reducers/reducerType'
import { RoomReducer } from '../../reducers/room/defaultState'
import isEqual from 'lodash/isEqual'

const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual
)

const getParticipantInformation = (state: State): RoomReducer['participantInformation'] => state.room.participantInformation

const selectParticipantInformationMap = createDeepEqualSelector(
  [ getParticipantInformation ],
  (participantInformation) => {

    const participantInformationMap = new Map()

    for (const participant of participantInformation) {

      participantInformationMap.set(participant.id, participant)

    }

    return participantInformationMap

  }
)

export default selectParticipantInformationMap
